import type { Locale } from "@/lib/i18n";
import { pl, type ParagraphTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const paragraphTranslations: Record<Locale, ParagraphTranslations> = {
  pl,
  en,
  de,
};

export type { ParagraphTranslations };
